import { JSONSchema7 } from 'json-schema';
import { string, object, number } from 'yup';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import formatName from '../formatName';

export default (properties: JSONSchema7Properties) => {
  const labelSchema = properties['label'] as JSONSchema7;
  const idSchema = properties['id'] as JSONSchema7;
  const externalIdSchema = properties['externalId'] as JSONSchema7;
  const dataSchema = properties['data'] as JSONSchema7;
  const filenameSchema = properties['filename'] as JSONSchema7;
  const mimeTypeSchema = properties['mimeType'] as JSONSchema7;
  const widthSchema = properties['width'] as JSONSchema7;
  const heightSchema = properties['height'] as JSONSchema7;

  return object({
    [`${formatName(labelSchema.$id as string)}`]: string()
      .required('Required')
      .max(250, 'Must be at most 250 characters'),
    [`${formatName(idSchema.$id as string)}`]: string()
      .required('Required')
      .matches(/^[a-z0-9]+$/i, 'Must be alphanumeric'),
    [`${formatName(externalIdSchema.$id as string)}`]: string(),
    [`${formatName(dataSchema.$id as string)}`]: string(),
    [`${formatName(filenameSchema.$id as string)}`]:
      string().required('File is required'),
    [`${formatName(mimeTypeSchema.$id as string)}`]: string().required(
      'Extension is required'
    ),
    [`${formatName(widthSchema.$id as string)}`]:
      string().required('Width is required'),
    [`${formatName(heightSchema.$id as string)}`]:
      string().required('Height is required'),
    [`${formatName(properties['gridSize']?.$id as string)}`]: number()
  });
};
